module.exports = __webpack_public_path__ + "static/media/wagon-covered.8043b5af.svg";